<template>
  <div class="now-playing">
    <img
      v-if="item.attachments"
      :src="item.attachments"
      alt="Image"
      class="now-playing-img"
    />
    <img
      v-else
      src="../assets/images/dublab_default_file.png"
      alt="placeholder"
      loading="lazy"
      class="now-playing-img"
    />
    <div class="now-playing-info">
      <p class="now-playing-artist">{{ item.dj }}</p>
      <h1 class="now-playing-show-name">{{ item.showName }}</h1>
      <p class="now-playing-time-info">
        <span class="on-air">&#9679; On Air</span>
        <span> {{ item.formattedStart }} to {{ item.formattedEnd }}</span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "NowPlaying",
  props: {
    item: Object,
  },
};
</script>

<style scoped>
.now-playing {
  width: 100%;
  font-size: 1.4rem;
  border-bottom: 1px solid #000;
  margin-bottom: 2rem;
  grid-template-columns: 1fr 1fr 1fr;
  display: flex;
  /* height: max-content; */
  height: 300px;
  padding-bottom: 3rem;
  width: 100%;
}

.now-playing-info {
  padding-left: 20px;
}

.now-playing-show-name {
  font-size: 42px;
  padding-bottom: 8px;
}

.now-playing-img {
  width: 270px;
}

.on-air {
  color: red;
  padding-right: 2px;
}

@media (max-width: 1000px) {
  .now-playing {
    height: 128px;
  }
  .now-playing-img {
    width: 100px;
  }
  .now-playing-time-info {
    font-size: 1.1rem;
  }
  .now-playing-show-name {
    font-size: 2rem;
  }
}
</style>
